<span [ngClass]="spanClass" *ngIf="display">{{ ('layout.days.' + display) | translate }},</span>